<!-- Add this at the top of your template -->
<button class="mobile-menu-button" (click)="toggleSidebar()">
  <i class="fas fa-bars"></i>
</button>

<!-- The overlay must be the first element -->
<div class="overlay" [class.active]="isExpanded"></div>

<div class="sidebar" [class.expanded]="isExpanded" [class.compact]="isCompact">
  <!-- Toggle button -->
  <div class="toggle-wrapper">
    <button class="sidebar-toggle" (click)="toggleSidebar()">
      <div class="toggle-icon">
        <i class="fas fa-chevron-right"></i>
      </div>
    </button>
  </div>

  <!-- Logo section -->
  <div class="logo-section">
    <img src="/assets/logos/elearning-logo.png" alt="SIMVet logo" class="sidebar-logo" />
  </div>

  <!-- Navigation items -->
  <nav class="nav-items">
    <div class="nav-group">
      <!-- Main Navigation -->
      <div
        class="nav-item"
        routerLink="/patients"
        routerLinkActive="active"
        [title]="!isExpanded ? ('sidebar.myPatients' | translate) : ''"
      >
        <i class="fas fa-paw"></i>
        <span *ngIf="isExpanded">{{ 'sidebar.myPatients' | translate }}</span>
      </div>

      <div
        class="nav-item"
        routerLink="/control-panel"
        routerLinkActive="active"
        [title]="!isExpanded ? ('sidebar.controlPanel' | translate) : ''"
      >
        <i class="fas fa-tachometer-alt"></i>
        <span *ngIf="isExpanded">{{ 'sidebar.controlPanel' | translate }}</span>
      </div>

      <!-- E-Learning -->
      <div
        class="nav-item elearning"
        routerLink="/elearning/teacher"
        *ngIf="showElearning"
        routerLinkActive="active"
        [title]="!isExpanded ? ('sidebar.elearning' | translate) : ''"
      >
        <i class="fas fa-graduation-cap"></i>
        <span *ngIf="isExpanded">{{ 'sidebar.elearning' | translate }}</span>
      </div>

      <!-- Student Portal -->
      <div
        class="nav-item"
        *ngIf="isStudentOrAdmin"
        routerLink="/elearning/students"
        routerLinkActive="active"
        [title]="!isExpanded ? ('sidebar.studentPortal' | translate) : ''"
      >
        <i class="fas fa-user-graduate"></i>
        <span *ngIf="isExpanded">{{ 'sidebar.studentPortal' | translate }}</span>
      </div>

      <!-- Premium E-Learning -->
      <div
        class="nav-item premium-elearning"
        *ngIf="showPremiumElearning"
        routerLink="/elearning/premium"
        routerLinkActive="active"
        [title]="!isExpanded ? ('sidebar.premiumElearning' | translate) : ''"
      >
        <i class="fas fa-crown"></i>
        <span *ngIf="isExpanded">{{ 'sidebar.premiumElearning' | translate }}</span>
      </div>

      <!-- Vital Signs Monitor (fixed position) -->
      <div
        class="nav-item monitor"
        (click)="openVitalSignsMonitor()"
        [title]="!isExpanded ? ('sidebar.vitalSignsMonitor' | translate) : ''"
      >
        <i class="fas fa-tv"></i>
        <span *ngIf="isExpanded">{{ 'sidebar.vitalSignsMonitor' | translate }}</span>
      </div>

      <!-- EEG Monitor -->
      <div
        class="nav-item eeg-monitor"
        (click)="openEegMonitor()"
        [title]="!isExpanded ? ('sidebar.eegMonitor' | translate) : ''"
      >
        <i class="fas fa-brain"></i>
        <span *ngIf="isExpanded">{{ 'sidebar.eegMonitor' | translate }}</span>
      </div>

      <div
        class="nav-item"
        *ngIf="isAdmin"
        routerLink="/admin"
        routerLinkActive="active"
        [title]="!isExpanded ? ('sidebar.admin' | translate) : ''"
      >
        <i class="fas fa-user-shield"></i>
        <span *ngIf="isExpanded">{{ 'sidebar.admin' | translate }}</span>
      </div>
    </div>

    <div class="nav-group">
      <!-- User Related -->
      <div
        class="nav-item"
        (click)="onFeedback()"
        routerLinkActive="active"
        [title]="!isExpanded ? ('sidebar.peerFeedback' | translate) : ''"
      >
        <i class="fas fa-comments"></i>
        <span *ngIf="isExpanded">{{ 'sidebar.peerFeedback' | translate }}</span>
      </div>

      <div
        class="nav-item notifications"
        routerLink="/notifications"
        routerLinkActive="active"
        [title]="!isExpanded ? ('sidebar.notifications' | translate) : ''"
      >
        <i class="fas fa-bell"></i>
        <span *ngIf="isExpanded">{{ 'sidebar.notifications' | translate }}</span>
        <span class="notification-badge" *ngIf="unreadCount$ | async as count">
          {{ count > 99 ? '99+' : count }}
        </span>
      </div>

      <div
        class="nav-item"
        routerLink="/profile"
        routerLinkActive="active"
        [title]="!isExpanded ? ('sidebar.myProfile' | translate) : ''"
      >
        <i class="fas fa-user-circle"></i>
        <span *ngIf="isExpanded">{{ 'sidebar.myProfile' | translate }}</span>
      </div>
    </div>

    <div class="nav-group footer-group">
      <!-- Footer Items -->
      <div class="nav-item donate">
        <a
          href="https://www.paypal.com/donate/?hosted_button_id=7USQLL2SAPYPW"
          target="_blank"
          rel="noopener noreferrer"
          class="donate-link"
          [title]="!isExpanded ? ('sidebar.supportUs' | translate) : ''"
        >
          <i class="fab fa-paypal"></i>
          <span *ngIf="isExpanded">{{ 'sidebar.supportUs' | translate }}</span>
        </a>
      </div>

      <div
        class="nav-item logout"
        (click)="onLogout()"
        [title]="!isExpanded ? ('sidebar.logout' | translate) : ''"
      >
        <i class="fas fa-sign-out-alt"></i>
        <span *ngIf="isExpanded">{{ 'sidebar.logout' | translate }}</span>
      </div>
    </div>
  </nav>
</div>
